<form [formGroup]="form">
  <h1 class="title is-5 mt-6 mb-4 is-block">Login</h1>
  <div class="field mt-4">
    <div class="control has-icons-left has-icons-right">
      <input class="input" type="text" formControlName="username" placeholder="Benutzername" value="">
      <span class="icon is-small is-left"><fa-icon [icon]="faUser"></fa-icon></span>
    </div>
    <p class="help is-danger" *ngIf="isFormKeyInvalid('username')">Bitte hinterlegen Sie einen Benutzernamen.</p>
  </div>
  <div class="field mt-2 mb-2">
    <div class="control has-icons-left">
      <input class="input" type="password" formControlName="password" placeholder="Passwort" value="">
      <span class="icon is-small is-left"><fa-icon [icon]="faLock"></fa-icon></span>
    </div>
    <p class="help is-danger" *ngIf="isFormKeyInvalid('password')">Bitte hinterlegen Sie ein Passwort.</p>
  </div>
  <div *ngIf="formHandler.getFormError()" class="mb-2">
    <iw-shared-form-error [apiError]="formHandler.getFormError()"></iw-shared-form-error>
  </div>

  <iw-shared-form-submit-button [formStatus]="formHandler.getFormStatus()" (submit)="submit()" submitLabel="Anmelden"></iw-shared-form-submit-button>
</form>
